angular.module('gym.contacts').directive('membershipChangeDuringPaymentGenerationError', function() {
  return {
    restrict: 'EA',
    template: `<div class="alert alert-danger is-sm">
  Payment generation is currently in progress for this membership. Please wait for this step to complete before making changes.
</div>`
  };
});
